<div class="popup-content">
  <!-- <span mat-dialog-title class="header-content">{{dialogContent.headerText}}
  <span class="dialog-container__header--close icon-requisition-denied" (click)="close()"></span>
</span> -->
<div mat-dialog-title class="header-content">
  <div class="header--title">{{dialogContent.headerText}} </div>
  <div class="header--close icon-requisition-denied" (click)="dialogRef.close(dialogContent.cancelHelpText)"></div>
</div>
<div mat-dialog-content class="content-container">
  <span class="d-block">{{dialogContent.contentText}} </span>
  @if (dialogContent && dialogContent.idleTimeoutBool) {
    <span class="d-block">{{commonService.popupDialogText}} </span>
  }
  <span class="strong-content">{{dialogContent.strongText}}</span>
</div>
<div mat-dialog-actions class="actions-div popup-button" [ngClass]="dialogContent.confirmHelpText === 'CONFIRM' ? 'confirmAvailable': ''">
  @if (dialogContent.cancelText) {
    <button  mat-flat-button class="cancel" [id]="dialogContent.cancelHelpText?dialogContent.cancelHelpText:'cancelPopupButton'" [ngClass]="dialogContent.cancelHelpText" (click)="dialogRef.close(dialogContent.cancelHelpText)">{{dialogContent.cancelText}}</button>
  }
  <button mat-button class="confirm large-button-mobile-confirm" [id]="dialogContent.confirmHelpText?dialogContent.confirmHelpText:'confirmPopupButton'" [ngClass]="dialogContent.confirmHelpText" [mat-dialog-close]="true" (click)="dialogRef.close(dialogContent.confirmHelpText)">{{dialogContent.confirmText}}</button>
</div>
</div>
